module.exports = __webpack_public_path__ + "static/img/img5.e86b028.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qmyd/qgz/img5.jpeg
// module id = k0to
// module chunks = 36